/* __next_internal_client_entry_do_not_use__ Block auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import * as React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1683))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.261Z
 */ export var Block = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M0.856934 12C0.856934 14.9553 2.03091 17.7895 4.1206 19.8792C6.21029 21.9689 9.04452 23.1429 11.9998 23.1429C14.9551 23.1429 17.7893 21.9689 19.879 19.8792C21.9687 17.7895 23.1426 14.9553 23.1426 12C23.1426 9.04477 21.9687 6.21054 19.879 4.12085C17.7893 2.03115 14.9551 0.857178 11.9998 0.857178C9.04452 0.857178 6.21029 2.03115 4.1206 4.12085C2.03091 6.21054 0.856934 9.04477 0.856934 12V12Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M4.12109 19.8788L19.8788 4.12109",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "Block", function(strictLocalize) {
    return {
        viewBox: "0 0 24 24",
        titleAccess: strictLocalize({
            id: "NZ9mzg",
            defaultMessage: [
                {
                    type: 0,
                    value: "Block"
                }
            ]
        }),
        fill: "none",
        color: Core.icon.default
    };
});
